// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-86ffdd6c] .el-card__body{padding-top:0}.titleactive[data-v-86ffdd6c]{color:#475570!important}.title[data-v-86ffdd6c]{color:#8d9ab2}[data-v-86ffdd6c] .el-divider__text{color:rgba(48,49,51,.5)}.diaTitle[data-v-86ffdd6c]{position:absolute;top:23px;left:80px}.btnClass[data-v-86ffdd6c]{display:flow-root;margin-top:5px}", ""]);
// Exports
module.exports = exports;
